export function delay(ms: number): Promise<void> {
    return new Promise((resolve) => { setTimeout(resolve, ms); });
}

/**
 * Converts an IANA timezone identifier into a short timezone abbreviation.
 * @param timezone - The IANA timezone identifier (e.g., 'Australia/Sydney').
 * @param date - An optional date to consider for daylight saving adjustments (default: current date).
 * @returns The short timezone abbreviation (e.g., 'AEST') or null if conversion fails.
 */
export function getShortTimezoneName(timezone: string, date: Date = new Date()): string | null {
    try {
        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            timeZoneName: "short",
        });

        // Get the formatted parts which include the short timezone name
        const parts = formatter.formatToParts(date);
        const timeZonePart = parts.find((part) => part.type === "timeZoneName");

        return timeZonePart?.value || null; // Return the short timezone name or null if not found
    } catch (error) {
        return null; // Return null if the timezone is invalid
    }
}
